import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { get, map, size, take } from "lodash";

import React from "react";

const LIMIT_OF_FAILED_PHOTO_UPLOADS_TO_LIST = 10;

export const FailedPhotoUploadDialog = ({
  open,
  reason,
  handleClose,
  failedPhotoUploads,
}) => {
  const numFailedPhotoUploads = size(failedPhotoUploads);
  const limitOfFailedPhotoUploadsToList = take(
    failedPhotoUploads,
    LIMIT_OF_FAILED_PHOTO_UPLOADS_TO_LIST,
  );

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Partial Failure</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Stack
              spacing={1}
              direction="column"
              alignItems="center"
              justifyContent="flex-start"
            >
              <Typography variant="p" component="b">
                {`${numFailedPhotoUploads} photos failed to save. ${reason}`}
              </Typography>
              {map(limitOfFailedPhotoUploadsToList, (failure, i) => (
                <Grid container key={i}>
                  <Grid item md={5}>
                    <Typography variant="p" component="b">
                      {get(failure, "file")} failed to upload.
                    </Typography>
                  </Grid>
                </Grid>
              ))}
              {numFailedPhotoUploads >
                LIMIT_OF_FAILED_PHOTO_UPLOADS_TO_LIST && (
                <Typography variant="p" component="b">
                  {`and ${numFailedPhotoUploads - LIMIT_OF_FAILED_PHOTO_UPLOADS_TO_LIST} others.`}
                </Typography>
              )}
            </Stack>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            autoFocus
            style={{
              backgroundColor: "#214986",
              color: "white",
              fontSize: "16px",
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
